import styled from 'styled-components';

export const InfoCard = styled.div`
  /* width: 32%; */
  height: 380px;
  border-radius: 10px;
  border: ${({ isSelected }) => (isSelected ? '1px solid #15C7A7' : '0.4px solid #d4d8dd80')};
`;

export const CardHeader = styled.div`
  background-color: white;
  height: 65px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  align-items: center;
  display: flex;
  padding: 0 15px;
  justify-content: space-between;
`;

export const CardLabel = styled.p`
  font-family: 'Nunito', sans-serif;
  font-weight: 600;
  font-style: 'SemiBold';
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0px;
  vertical-align: middle;
  color: #212529;
`;
export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 315px; // 380 - 65px (CardHeader)
`;

export const CardItem = styled.div`
  background-color: ${({ $color }) => $color || 'white'};
  min-height: 65px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: 5px 15px;
`;

export const Key = styled.div`
  font-family: 'Nunito', sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0px;
  vertical-align: middle;
  color: #6c757d;
`;

export const Value = styled.div`
  font-family: 'Nunito', sans-serif;
  cursor: pointer;
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0px;
  vertical-align: middle;
  color: ${({ $textColor }) => $textColor || '#212529'};
  max-width: 65%;
  overflow-wrap: break-word;
  word-break: break-word;
  white-space: normal;
  text-decoration: ${({ $underline }) => ($underline ? 'underline' : 'none')};
`;

export const CardBody = styled.div`
  overflow-y: auto;
  height: 310px;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
    transition: background-color 0.3s;
    border-radius: 12px;
  }

  &:hover::-webkit-scrollbar-thumb {
    background-color: #6c757d;
  }

  &:hover::-webkit-scrollbar-track {
    background: transparent;
  }

  &:hover::-webkit-scrollbar {
    width: 4px;
  }
`;

export const NoteWrapper = styled.div`
  width: 354px;
  padding: 25px 20px 22px 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  background-color: #fff3ea;
  border-radius: 10px;
`;

export const NoteTitle = styled.p`
  color: #212529;
  font-family: 'Nunito', sans-serif;

  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`;

export const NoteText = styled.p`
  color: #212529;
  font-family: 'Nunito', sans-serif;

  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  width: auto;
  max-width: 100%;
`;

export const TableHead = styled.thead`
  background-color: #ecf1fb;
`;

export const TableHeader = styled.th`
  border: 1px solid #dfdfdf80;
  padding: 10px 20px;
  text-align: center;
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #ffffff;
  }
  &:hover {
    background-color: #f1f1f1;
  }
`;

export const TableCell = styled.td`
  border: 1px solid #dfdfdf80;
  padding: 10px 20px;
  text-align: center;
  font-family: 'Nunito', sans-serif;

  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0px;
  color: #6c757d;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: center;
`;

export const HeaderTitle = styled.span`
  font-family: 'Nunito', sans-serif;

  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  color: #212529;
`;

export const CardGroupWrapper = styled.div`
  margin-bottom: ${({ $isLast }) => ($isLast ? '0px' : '12px')};
  border: ${({ $isSelected }) =>
    $isSelected ? '1px solid #15C7A7' : '1px solid transparent'};
  cursor: pointer;
  transition: border 0.3s ease;
`;

export const Span = styled.div``;

export const Icon = styled.img`
  cursor: pointer;
`;

export const Acton = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const IconWrapper = styled.div`
  position: relative;
`;

export const EmptyData = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
`;
